import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { BudgetDefaultService } from './budget-default.service';

import { Section } from 'app/modules/public/master-page/budget-home/sectionmodel';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { FuseAlertType } from '@fuse/components/alert';
import { CardHomeService } from 'app/services/card-service.service';
import { airline } from 'app/types/listedairlines.type';
import { listedplace } from 'app/types/listedplace.type';
import { Observable, filter, map, of, startWith } from 'rxjs';
import { MyErrorStateMatcher } from '../../libs';
import { BudgetQuoteComponent } from '../budget-quote/budget-quote.component';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { BudgetQuoteService } from '../budget-quote/budget-quote.service';
import { HttpParams } from '@angular/common/http';
import { StepperOrientation } from '@angular/cdk/stepper';
import { BudgetHomeService } from 'app/services/budget-home.service';
import { DateAdapter } from '@angular/material/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BudgetPrivateQuoteService } from '../budget-privatequote/budget-privatequote.service';
import { Title } from '@angular/platform-browser';
import { AvailableLangs, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-budget-default',
  templateUrl: './budget-default.component.html',
  styleUrls: ['./budget-default.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class BudgetDefaultComponent implements OnInit {

//#region Properties

  //#region FormControl
  selected = new FormControl('valid', [Validators.required, Validators.pattern('valid')]);
  selectFormControl = new FormControl('valid', [Validators.required, Validators.pattern('valid')]);
  nativeSelectFormControl = new FormControl('valid', [
    Validators.required,
    Validators.pattern('valid'),
  ]);

  controlOrigin = new FormControl({ value: '' });
  controlDestination = new FormControl({ value: ''});
  controlOneWayRoundtrip = new FormControl('oneway' );
  controlDate = new FormControl({ value: '' });
  controlTime = new FormControl({ value: '' });
  controlDateReturn = new FormControl({ value: '', disabled: true });
  controlTimeReturn = new FormControl({ value: '', disabled: true });

  controlPrivateOrigin = new FormControl({ value: ''});
  controlPrivateDestination = new FormControl({ value: ''});

  controlAirlines = new FormControl({ value: ''});
  controlAirlinesReturn = new FormControl({ value: ''});

   //#endregion FormControl

   //#region Lists
   
    sections: any[] = [];
    listedPlaces: any[] = [];
    listedPlacesString: string[] = [];
    listedPrivatePlaces: any[] = [];
    listedPrivatePlacesString: string[] = [];
    listedPlacesPrivateOrigin: any[] = [];
    listedPlacesPrivateOriginString: string[] = [];
    listedAirlines: airline[] = [];
    listedAirlinesString: string[] = [];
  

    filteredOptionsOrigin: Observable<string[]>;
    filteredOptionsDestination: Observable<string[]>;
    filteredOptionsPrivateOrigin: Observable<string[]>;
    filteredOptionsPrivateDestination: Observable<string[]>;
    filteredOptionsAirlines: Observable<string[]>;
    filteredOptionsAirlinesReturn: Observable<string[]>;

    listedImages: any[] = [];
  //#endregion Lists

  //#region Forms

  airporttransferForm: FormGroup = this._formBuilder.group({
    vchOrigin: this.controlOrigin
  ,vchDestination: this.controlDestination
  ,vchOneWayRoundtrip: this.controlOneWayRoundtrip
  ,vchDateTime: ['']
  ,vchDate: this.controlDate
  ,vchTime:  ['00:00']
  ,vchDateReturn: this.controlDateReturn
  ,vchTimeReturn:  ['00:00']
  ,vchDateTimeReturn: ['']
  ,vchName: [' ']
  ,vchCellPhone: ['']
  ,vchEmail: ['']
  ,vchPax: ['', [Validators.required]]
  ,vchBagage: ['']
  ,vchAirline: this.controlAirlines
    ,vchFlightNumber: ['']
    ,vchAirlineReturn: this.controlAirlinesReturn
    ,vchFlightNumberReturn: ['']
  ,vchObservations: ['']
  ,vchSubjectEmail: ['AirPort Transfer Reserve']
  ,vchModule: ['[CTE]']
  ,vchModuleReq: ['ATH']
  ,vchStatus: ['Created']
});
  privatetransportationForm: FormGroup= this._formBuilder.group({
    vchOrigin: this.controlPrivateOrigin
     ,vchDestination: this.controlPrivateDestination
    ,vchPickUp: ['']
    ,vchDate: ['', [Validators.required]]
    ,vchTime: ['']
    ,vchName: ['']
    ,vchCellPhone: ['']
    ,vchEmail: ['']
    ,vchPax: ['', [Validators.required]]
    ,vchObservations: ['']
    ,vchSubjectEmail: ['Private Transportarion Reserve']
    ,vchModule: ['[CTE]']
    ,vchModuleReq: ['PTH']
  });

  cardsForm: FormGroup;
  imagesForm: FormGroup;
  StatusCard: FormGroup;
  PriceForm: FormGroup;

  itemSettingAirportForm: any = { bitActive: false };
  itemSettingPrivateForm: any = { bitActive: false };

  //#endregion Forms

  //#region Others Variables

  _budgetQuoteComponent: BudgetQuoteComponent;
  statusCount: number;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,  // Cambiado a false
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      400: { items: 1 },
      740: { items: 1 },
      940: { items: 1 },
      1200: { items: 1 }
    },
    nav: false,
    margin: 0,  // Añadido
    stagePadding: 0,  // Añadido
    autoWidth: false,  // Añadido
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: false  // Añadido
};
loadedCarousel = false;
  matcher = new MyErrorStateMatcher();
  yearlyBilling: boolean = true;
  isEditable = true;
  showAlert: boolean = false;
  name = 'Angular ';
  today = new Date();
  currentDayString = '';
  pipe = new DatePipe('en-GB');
  public visibleDTMReturn = 'none';
  stepperOrientation: Observable<StepperOrientation>;
  existingTags = ['AirPort', 'airPort', 'AIRPORT', 'airport', 'Airport'];
  alert: { type: FuseAlertType; message: string } = {
    type   : 'success',
    message: ''
  };
  minDate: Date;
  maxDate: Date;

  folderImages: string = '/assets/images/slidehome/';
  errorImage: boolean = false;
  bitCreateBookings: boolean = false;

    availableLangs: AvailableLangs;
    activeLang: string;
    flagCodes: any;
  //#endregion Others Variables

//#endregion Properties

//#region Init

  constructor(
    private _formBuilder: FormBuilder
    ,private _budgethomeService: BudgetHomeService
    ,private _cardService: CardHomeService
    ,private _budgetDefaultService: BudgetDefaultService
    ,private router: Router
    ,private _budgetQuoteService: BudgetQuoteService
    ,private _budgetPrivateQuoteService: BudgetPrivateQuoteService
    ,private dateAdapter: DateAdapter<Date>
    , breakpointObserver: BreakpointObserver
    ,private titleService: Title
    ,private route: ActivatedRoute
    ,private translocoService: TranslocoService
  ) {

  
  
  
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));
    
    let paramsAppend = new HttpParams();
    paramsAppend = paramsAppend.set("module", "Default");
    
    this._budgethomeService.GetModuleConfig(paramsAppend).subscribe((response) => {
      var listRangeDateTime = response.moduleconfig.listRangeDateTime;  
      this.bitCreateBookings = response.moduleconfig.objCompany.objBranchGeneral.bitCreateBookings; 
      this.dateAdapter.setLocale('en-GB');
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      let ChangedFormat = this.pipe.transform(this.today, 'dd');
      this.currentDayString = ChangedFormat;
      this.minDate = new Date(currentYear + listRangeDateTime[0].intIniYear, currentMonth + listRangeDateTime[0].intIniMonth, Number(this.currentDayString) + listRangeDateTime[0].intIniDay);
      this.maxDate = new Date(currentYear + listRangeDateTime[0].intFinYear, currentMonth + listRangeDateTime[0].intFinMonth, Number(this.currentDayString) + listRangeDateTime[0].intFinDay);

      this.listedImages = response.moduleconfig.listImages;
      if(this.listedImages){
       this.loadedCarousel = true;
      }
      try{
        this.itemSettingAirportForm = response.moduleconfig.listItemsSettings.find(c => c.bitTypeForm === true && c.vchName.toLowerCase().includes('airport') );
        
      }
      catch{

      }
      try{
        
        this.itemSettingPrivateForm = response.moduleconfig.listItemsSettings.find(c => c.bitTypeForm === true && c.vchName.toLowerCase().includes('private') );
      }
      catch{

      }

    }, (error) => {
        console.log('error:',error.message);
    });

  }

  ngOnInit(): void {
   
    // Get the available languages from transloco
    this.availableLangs = this.translocoService.getAvailableLangs();

    // Subscribe to language changes
    this.translocoService.langChanges$.subscribe((activeLang) => {
        // Get the active lang
        this.activeLang = activeLang;



        this.listedPlacesString=[];
        this.listedPlaces.forEach((currentValue, index) => {
          try{
            var selectedObj= currentValue.translations.find(c => c.vchLangCode2 === this.activeLang );
            if(selectedObj !== null && selectedObj !== undefined){
              this.listedPlacesString.push(selectedObj.vchName);
            }
            else{
              this.listedPlacesString.push(currentValue.vchName);
            }
          }
          catch{
            this.listedPlacesString.push(currentValue.vchName);
          }
          
        });
         
        this.controlOrigin.setValue(this.airporttransferForm.get('vchOrigin').value);
        this.controlDestination.setValue(this.airporttransferForm.get('vchDestination').value);
        // this.filteredOptionsOrigin = this.controlOrigin.valueChanges.pipe(
        //   startWith(''),
        //   map(value => this._filterplaces(value)),
        // );
        // this.filteredOptionsOrigin = of(this._filterplaces(this.controlOrigin.value));

        this.listedPlacesPrivateOriginString=[];
        this.listedPlacesPrivateOrigin.forEach((currentValue, index) => {
          try{
            var selectedObj= currentValue.translations.find(c => c.vchLangCode2 === this.activeLang );
            if(selectedObj !== null && selectedObj !== undefined){
              this.listedPlacesPrivateOriginString.push(selectedObj.vchName);
            }
            else{
              this.listedPlacesPrivateOriginString.push(currentValue.vchName);
            }
          }
          catch{
            this.listedPlacesPrivateOriginString.push(currentValue.vchName);
          }
          
        });

        this.listedPrivatePlacesString=[];
        this.listedPrivatePlaces.forEach((currentValue, index) => {
          try{
            var selectedObj= currentValue.translations.find(c => c.vchLangCode2 === this.activeLang );
            if(selectedObj !== null && selectedObj !== undefined){
              this.listedPrivatePlacesString.push(selectedObj.vchName);
            }
            else{
              this.listedPrivatePlacesString.push(currentValue.vchName);
            }
          }
          catch{
            this.listedPrivatePlacesString.push(currentValue.vchName);
          }
          
        });
         
        this.controlPrivateOrigin.setValue(this.privatetransportationForm.get('vchOrigin').value);
        this.controlPrivateDestination.setValue(this.privatetransportationForm.get('vchDestination').value);

    });

    this.inicio();
    this.iniciotours();
   }

   
   iniciotours(): void{
     this._cardService.getAllSections().subscribe((sections) => {
       this.sections = sections.sectionsList;

       this.sections.forEach((section, sectionIndex) => {
         this.cardsForm = this._formBuilder.group({
           uidSection: section.uidSection
         });

         this._cardService.GetCards(this.cardsForm.getRawValue()).then((cardsResponse) => {
           section.cards = cardsResponse;
           section.cards.forEach((card, cardIndex) => {
             //metodo imagenes
             this.imagesForm = this._formBuilder.group({
               uidCard: card.uidCard
             });
             this._cardService.GetImages(this.imagesForm.getRawValue()).then((imagesResponse) => {
               card.images = imagesResponse;
             }).catch((error) => {
               console.log('Error al obtener imágenes para la tarjeta: ' + error);
             });
             //metodo status
             this.StatusCard = this._formBuilder.group({
               uidCard: card.uidCard
             });
             this._cardService.GetStatus(this.StatusCard.getRawValue()).then((statusresponse) => {
               card.status = statusresponse;
               card.statusCount = statusresponse.length;
               if (Array.isArray(statusresponse) && statusresponse.length > 0) {
                 // Suma de los valores de la propiedad 'rating'
                 const sumaRating = statusresponse.reduce((acumulador, status) => acumulador + (status && status.rating ? status.rating : 0), 0);
                 // Total de elementos en el arreglo
                 const totalElementos = statusresponse.length;
                 // Calcular el porcentaje
                 const ratingPercentage = (sumaRating / (totalElementos)) * 10;
                 // Asignar el resultado al modelo Card
                 const ratingPercentage1 = ratingPercentage;
                 card.ratingPercentage = parseFloat(ratingPercentage1.toFixed(0));
             } else {
                 card.ratingPercentage = null; // Manejo de casos donde los valores son nulos o no válidos.
             }

             if (Array.isArray(statusresponse) && statusresponse.length > 0) {
               // Filtrar los elementos que tienen la propiedad 'booleanValue' como true
               const booleanValuesPositivos = statusresponse.filter(status => status && status.recomendation === true);

               // Calcular el porcentaje
               const porcentajeBooleanPositivos = (booleanValuesPositivos.length / statusresponse.length) * 100;

               // Limitar la cantidad de decimales a 2
               const porcentajeDosDecimales = parseFloat(porcentajeBooleanPositivos.toFixed(2));

               // Asignar el resultado al modelo Card
               card.porcentajeBoolean = porcentajeDosDecimales;
           } else {
               card.porcentajeBoolean = null; // Manejo de casos donde los valores son nulos o no válidos.
           }

               console.log(this.statusCount);
             }).catch((error) => {
               console.log('Error al obtener status para la tarjeta: ' + error);
             });
             //metodo precio
             this.PriceForm = this._formBuilder.group({
               uidCard: card.uidCard
             });
             this._cardService.GetPrices(this.PriceForm.getRawValue()).then((priceresponse) => {
               card.price = priceresponse;
                 // Calcula el porcentaje
                 if (Array.isArray(priceresponse)) {
                   priceresponse.forEach((price) => {
                     // Realiza operaciones en cada elemento del arreglo
                     if (price && price.intAmount && price.intDiscount) {
                       if (price && price.intAmount && price.intDiscount) {
                         const amount = price.intAmount;
                         const discount = price.intDiscount;
                         // Calcula el precio original
                         const percentage = amount / (1 - discount / 100);
                       // Asigna el resultado al modelo Card
                       card.pricePercentage = percentage;
                     } else {
                       card.pricePercentage = null; // Manejo de casos donde los valores son nulos o no válidos.
                     }
                   }});
                 } else {
                   console.error('La respuesta de la API no es un arreglo.');
                 }
             }).catch((error) => {
               console.log('Error al obtener presio para la tarjeta: ' + error);
             });
           });
         }).catch((error) => {
           console.log('Error al obtener tarjetas para la sección: ' + error);
         });
       });
     });

   }

   inicio(): void{
     this.getlistedplaces();
     this.getlistedprivateplaces();
     this.getlistedplacesprivateorigin();
     this.getlistedairlines();

    //  this.airporttransferForm = this._formBuilder.group({
    //      vchOrigin: this.controlOrigin
    //    ,vchDestination: this.controlDestination
    //    ,vchOneWayRoundtrip: this.controlOneWayRoundtrip
    //    ,vchDateTime: ['']
    //    ,vchDate: this.controlDate
    //    ,vchTime:  ['00:00']
    //    ,vchDateReturn: this.controlDateReturn
    //    ,vchTimeReturn:  ['00:00']
    //    ,vchDateTimeReturn: ['']
    //    ,vchName: [' ']
    //    ,vchCellPhone: ['']
    //    ,vchEmail: ['']
    //    ,vchPax: ['', [Validators.required]]
    //    ,vchBagage: ['']
    //    ,vchAirline: this.controlAirlines
    //      ,vchFlightNumber: ['']
    //      ,vchAirlineReturn: this.controlAirlinesReturn
    //      ,vchFlightNumberReturn: ['']
    //    ,vchObservations: ['']
    //    ,vchSubjectEmail: ['AirPort Transfer Reserve']
    //    ,vchModule: ['[CTE]']
    //    ,vchModuleReq: ['ATH']
    //    ,vchStatus: ['Created']
    //  });

     this.airporttransferForm.get('vchAirline').setValue('');
     this.airporttransferForm.get('vchAirlineReturn').setValue('');

    //  this. privatetransportationForm = this._formBuilder.group({
    //   vchOrigin: this.controlPrivateOrigin
    //    ,vchDestination: this.controlPrivateDestination
    //   ,vchPickUp: ['']
    //   ,vchDate: ['', [Validators.required]]
    //   ,vchTime: ['']
    //   ,vchName: ['']
    //   ,vchCellPhone: ['']
    //   ,vchEmail: ['']
    //   ,vchPax: ['', [Validators.required]]
    //   ,vchObservations: ['']
    //   ,vchSubjectEmail: ['Private Transportarion Reserve']
    //   ,vchModule: ['[CTE]']
    //   ,vchModuleReq: ['PTH']
    // });
   }

  //#endregion Init

//#region Gets
   getlistedplaces(){
     this._budgetDefaultService.getlistedplaces().subscribe((places) => {
         this.listedPlacesString=[];
         this.listedPlaces=[];
         this.listedPlaces=places;
         this.listedPlaces.forEach((currentValue, index) => {
            try{
              var selectedObj= currentValue.translations.find(c => c.vchLangCode2 === this.activeLang );
              if(selectedObj !== null && selectedObj !== undefined){
                this.listedPlacesString.push(selectedObj.vchName);
              }
              else{
                this.listedPlacesString.push(currentValue.vchName);
              }
            }
            catch{
              this.listedPlacesString.push(currentValue.vchName);
            }
         });
        //  console.log('this.listedPlaces:',this.listedPlaces);
         this.filteredOptionsOrigin = this.controlOrigin.valueChanges.pipe(
           startWith(''),
           map(value => this._filterplaces(value)),
         );
         this.filteredOptionsDestination = this.controlDestination.valueChanges.pipe(
           startWith(''),
           map(value => this._filterplaces(value)),
         );
         
         
     }, (error) => {
         console.log('error:',error);
     });
   }

   getlistedprivateplaces(){
     
       this._budgetDefaultService.getlistedprivateplaces().subscribe((privateplaces) => {
         this.listedPrivatePlacesString = [];
         this.listedPrivatePlaces = [];
         this.listedPrivatePlaces=privateplaces;
        //  console.log('getlistedprivateplaces',this.listedPrivatePlaces);
         this.listedPrivatePlaces.forEach((currentValue, index) => {
          
          try{
            var selectedObj= currentValue.translations.find(c => c.vchLangCode2 === this.activeLang );
            if(selectedObj !== null && selectedObj !== undefined){
              this.listedPrivatePlacesString.push(selectedObj.vchName);
            }
            else{
              this.listedPrivatePlacesString.push(currentValue.vchName);
            }
          }
          catch{
            this.listedPrivatePlacesString.push(currentValue.vchName);
          }
          
        });

        this.filteredOptionsPrivateDestination = this.controlPrivateDestination.valueChanges.pipe(
           startWith(''),
           map(value => this._filterprivateplaces(value)),
        );

     }, (error) => {
         console.log('error:',error);
     });
   }

   getlistedplacesprivateorigin(){
    this._budgethomeService.getlistedplacesprivateorigin().subscribe((places) => {
      this.listedPlacesPrivateOriginString = [];
      this.listedPlacesPrivateOrigin = [];
      this.listedPlacesPrivateOrigin=places;

      this.listedPlacesPrivateOrigin.forEach((currentValue, index) => {
          
          try{
            var selectedObj= currentValue.translations.find(c => c.vchLangCode2 === this.activeLang );
            if(selectedObj !== null && selectedObj !== undefined){
              this.listedPlacesPrivateOriginString.push(selectedObj.vchName);
            }
            else{
              this.listedPlacesPrivateOriginString.push(currentValue.vchName);
            }
          }
          catch{
            this.listedPlacesPrivateOriginString.push(currentValue.vchName);
          }
          
      });

      this.filteredOptionsPrivateOrigin = this.controlPrivateOrigin.valueChanges.pipe(
        startWith(''),
        map(value => this._filterplacesprivateorigin(value)),
      );
      
  }, (error) => {
      console.log('error:',error);
  });
}

   getlistedairlines(){
     //console.log('getlistedprivateplaces');
       this._budgetDefaultService.getlistedairlines().subscribe((airlines) => {
         this.listedAirlinesString = [];
         this.listedAirlines=[];
         this.listedAirlines=airlines;
         this.listedAirlines.forEach((currentValue, index) => {
           this.listedAirlinesString.push(currentValue.vchName);
         });
         this.filteredOptionsAirlines = this.controlAirlines.valueChanges.pipe(
           startWith(''),
           map(value => this._filterairlines(value)),
         );
         this.filteredOptionsAirlinesReturn = this.controlAirlinesReturn.valueChanges.pipe(
           startWith(''),
           map(value => this._filterairlines(value)),
         );

     }, (error) => {
         console.log('error:',error);
     });
   }

   private _filterplaces(value: string): string[] {
     if(value!==null){
       if(value===''){
         return this.listedPlacesString;
       }
       else{
         try{
           const filterValue = value.toLowerCase();
           return  this.listedPlacesString.filter(option => option.toLowerCase().includes(filterValue)) ;
         }
         catch{
           return this.listedPlacesString;
         }

       }
     }
   }

   private _filterprivateplaces(value: string): string[] {
    if(value!==null){
      if(value===''){
        return this.listedPrivatePlacesString;
      }
      else{
        try{
          const filterValue = value.toLowerCase();
          return  this.listedPrivatePlacesString.filter(option => option.toLowerCase().includes(filterValue)) ;
        }
        catch{
          return this.listedPrivatePlacesString;
        }

      }
    }
  }

  private _filterplacesprivateorigin(value: string): string[] {
   if(value!==null){
     if(value===''){
       return this.listedPlacesPrivateOriginString;
     }
     else{
       try{
         const filterValue = value.toLowerCase();
         return  this.listedPlacesPrivateOriginString.filter(option => option.toLowerCase().includes(filterValue)) ;
       }
       catch{
         return this.listedPlacesPrivateOriginString;
       }
       
     }
   }
 }

  private _filterairlines(value: string): string[] {
    if(value!==null){
      if(value===''){
        return this.listedAirlinesString;
      }
      else{
        try{
          const filterValue = value.toLowerCase();
          return  this.listedAirlinesString.filter(option => option.toLowerCase().includes(filterValue)) ;
        }
       catch{
        return this.listedAirlinesString;
       }
      }
    }
  }

  getActiveCardLangTitle(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchCardTitle;
      }
      else{
        return card.vchTitle;

      }
    }
    catch{
      return card.vchTitle;
    }
  }
  getActiveCardLangDescription(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchCardDescription;
      }
      else{
        return card.vchDescription;

      }
    }
    catch{
      return card.vchDescription;
    }
  }
  getActiveCardLangRecommendation(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang ); 
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchToolTipRecommendations;
      }
      else{
        return card.vchToolTipRecommendations;

      }
    }
    catch{
      return card.vchToolTipRecommendations;
    }
  }
  getActiveCardLangValuations(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchToolTipValuations;
      }
      else{
        return card.vchToolTipValuations;

      }
    }
    catch{
      return card.vchToolTipValuations;
    }
  }
  getActiveCardLangEvaluations(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchToolTipEvaluations;
      }
      else{
        return card.vchToolTipEvaluations;

      }
    }
    catch{
      return card.vchToolTipEvaluations;
    }
  }
  getCardLangButtonText(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchCardsButtonText;
      }
      else{
        return card.vchCardsButtonText;

      }
    }
    catch{
      return card.vchCardsButtonText;
    }
  }
  getActiveCardLangPaxPack(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchCardPaxPack;
      }
      else{
        return card.vchType;

      }
    }
    catch{
      return card.vchType;
    }
  }
  getActiveCardLangUnitsTimeDuration(card: any): string{
    try{
      var selectedObj= card.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchCardUnitsTimeDuration;
      }
      else{
        return 'Hours';

      }
    }
    catch{
      return 'Hours';
    }
  }
  getSectionLangTitle(section: any): string{
    try{
      var selectedObj= section.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchTitle;
      }
      else{
        return section.vchTitle;
  
      }
    }
    catch{
      return section.vchTitle;
    }
  }
  getSectionLangDescription(section: any): string{
    try{
      var selectedObj= section.translations.find(c => c.vchLangCode2 === this.activeLang );
      if(selectedObj !== null && selectedObj !== undefined){
        return selectedObj.vchDescription;
      }
      else{
        return section.vchDescription;
  
      }
    }
    catch{
      return section.vchDescription;
    }
  }

//#endregion Gets

//#region Validate

   private _validatewordAirPort(): boolean{
     // console.log(this.controlOrigin.value);
     // console.log(this.controlDestination.value);
     var origen = this.controlOrigin.value as string;
     var destino = this.controlDestination.value as string;
     var objorigin =    this.listedPlaces.find(obj => (obj.translations.find(subobj => subobj.vchName === origen) || obj.vchName === origen));
     var objdestination =    this.listedPlaces.find(obj => (obj.translations.find(subobj => subobj.vchName === destino) || obj.vchName === destino));
     if(origen !== '' && destino !== ''){
       var booOrigin = false;
       var booDestination = false;
       var validate = false;
          
          booOrigin = objorigin.bitAirport;
          booDestination = objdestination.bitAirport;


       if(booOrigin === false && booDestination === false){
         //console.log('invalid');
         // this.controlOrigin.setErrors({ 'NoAPContent'  : true });
         // this.controlDestination.setErrors({ 'NoAPContent'  : true });

       }
       else{
         //  this.controlOrigin.clearValidators();
         //  this.controlOrigin.updateValueAndValidity();

         //  this.controlDestination.clearValidators();
         //  this.controlDestination.updateValueAndValidity();

         //  this.controlOrigin.setErrors([Validators.required]);
         //  this.controlOrigin.updateValueAndValidity();
         //  this.controlDestination.setErrors([Validators.required]);
         //  this.controlDestination.updateValueAndValidity();

         if(origen !==  destino){
           validate = true;
         }
       }
       return validate;
     }
   }

   private _validateTime():boolean{
     try
     {
       // this.pipe.transform(this.controlTime.value, 'HH:mm:ss')
       //console.log(this.pipe.transform(this.controlDate.value, 'dd/MM/yyyy'));
       const date: Date = this.convertToLocalDate(this.controlDate.value);
       // console.log('date:'+date.getTime());
       if(this.controlOneWayRoundtrip.value === 'oneway')
       {

             //console.log(date);
             date.getDate();
             //return true;
             //console.log('fecha solo');
             const stime: string = this.controlTime.value;
             //console.log('antes time');
             //console.log(stime);
             if(stime){
               const time: Date =  this.toTime2(stime+':00');
               try
               {
                 // console.log(time);
                 if(time.toString() !== 'Invalid Date')
                 {
                   // console.log('time valida!!!');
                   return true;
                 }
                 else
                 {
                   // console.log('time invalida');
                   return false;
                 }
               }
               catch
               {
                 // console.log('time invalida');
                 return false;
               }
             }
             else{
               //console.log('timeisValid invalida');
                 return false;
             }
       }
       else
       {
         //const date: Date = this.convertToLocalDate(this.controlDate.value);
         const datereturn: Date = this.convertToLocalDate(this.controlDateReturn.value);
         // console.log('datereturn:'+datereturn.getTime());
         if(date.getTime()===datereturn.getTime()){
           //console.log('return es igual');
           const time: Date =  this.toTime2 (this.controlTime.value+':00');
           const timereturn: Date = this.toTime2(this.controlTimeReturn.value+':00');
           if(time<timereturn)
           {
             return true;
           }
           else
           {
             return false;
           }
         }
         else{
           if(date.getTime()<datereturn.getTime()){
             return true;
           }
           else{
             return false;
           }
         }
       }
     }
     catch
     {
       return false;
     }


   }

//#endregion Validate  

//#region Actions

  accesclick(): void
    {

      //console.log( this.form.get('uidEspecialidad').value);
        // Return if the form is invalid
        if (this.airporttransferForm.invalid) {
          return;
        }

      // Disable the form
      this.airporttransferForm.disable();

      // Hide the alert
      this.showAlert = false;

        var validateword = this._validatewordAirPort();
        var validatedate = this._validateTime();
        // this.airporttransferForm.enable();
        // return;
        if(validateword === false)
        {
          //console.log('error');

          if(validateword === false){
               var msg = this.translocoService.translateObject('AlertMessage-ValidationAirport1Place');
                this.alert = {
                  type: 'error',
                  message: msg
              };
          }
          else{
             var msg = this.translocoService.translateObject('AlertMessage-ValidationDateTimeInvalid');
              this.alert = {
                type: 'error',
                message: msg
            };
          }


          // Show the alert
          this.showAlert = true;
          this.airporttransferForm.enable();
        }else{
          //console.log(this.airporttransferForm.getRawValue());
          this._budgetQuoteComponent.reserveVisible = true;
          this._budgetQuoteComponent.reserveAccessForm.enable();
        }
    }

   reservetransferclick(): void
   {
     
     if(this.bitCreateBookings === false)
      {
        this.alert = 
        {
          type: 'error',
          message:'At this time the bookings system is not available. Please contact an executive.'
        };
        this.showAlert = true;
        return;
      }
     //console.log( this.form.get('uidEspecialidad').value);
       // Return if the form is invalid
       if (this.airporttransferForm.invalid) {
         return;
        }

     // Disable the form
     this.airporttransferForm.disable();

     // Hide the alert
     this.showAlert = false;

       var validateword = this._validatewordAirPort();
       var validatedate = this._validateTime();
       // this.airporttransferForm.enable();
       // return;
       if(validateword === false)
       {
         //console.log('error');

         if(validateword === false){
             var msg = this.translocoService.translateObject('AlertMessage-ValidationAirport1Place');
               this.alert = {
                 type: 'error',
                 message: msg
             };
         }
         else{
             var msg = this.translocoService.translateObject('AlertMessage-ValidationDateTimeInvalid');
             this.alert = {
               type: 'error',
               message: msg
           };
         }


         // Show the alert
         this.showAlert = true;
         this.airporttransferForm.enable();
       }else{
         //console.log(this.airporttransferForm.getRawValue());
         this._budgetQuoteService.setTranferData(this.airporttransferForm);
         this.router.navigateByUrl('quote');
        
        }
   }

   reservetransportationclick(): void
   {

      if(this.bitCreateBookings === false)
      {
        this.alert = 
        {
          type: 'error',
          message:'At this time the bookings system is not available. Please contact an executive.'
        };
        this.showAlert = true;
        return;
      }
     //console.log( this.form.get('uidEspecialidad').value);
       // Return if the form is invalid
       if (this.privatetransportationForm.invalid) {
         return;
     }


     // Hide the alert
     this.showAlert = false;

         this._budgetPrivateQuoteService.setTranferData(this.privatetransportationForm);
         this.router.navigateByUrl('privatequote');

   }

  irADestino(section: any, card: any) {
    // const navigationExtras: NavigationExtras = {
    //   queryParams: { uidCard: uidCard },
    //   skipLocationChange: false
    // };
    // this.router.navigate(['/public/details'], navigationExtras);
    const caracteresAEliminar = /[\\\/\\*\%\#\&\(\)\[\]\{\}\@]/g;
    this.router.navigate(['/public/details',this.getSectionLangTitle(section).replace(/\s+/g, '-').replace(caracteresAEliminar, ''), this.getActiveCardLangTitle(card).replace(/\s+/g, '-').replace(caracteresAEliminar, ''), card.uidCard]);
  }
//#endregion Actions 

//#region Converts

   getOptionText(option) {
      if(option!==null){
         if(typeof option === 'string' || option instanceof String){

           return option;
         }
         else
         {
           return option.value;
         }
      }
   }

   disabledDateTimeReturnControl(): void {
     if(this.controlOneWayRoundtrip.value === 'oneway'){
       this.controlDateReturn.disable();
       this.controlTimeReturn.disable();
       this.visibleDTMReturn = 'none';
     }
     else
     {
       this.controlDateReturn.enable();
       this.controlTimeReturn.enable();
       this.visibleDTMReturn = 'block';
     }

   }

   toTime(date: Date,timeString ):Date{
     var currentYear = date.getFullYear();
     var currentMonth = date.getUTCMonth();
     var ChangedFormat = this.pipe.transform(date, 'dd');
     var currentDayString = ChangedFormat;
     var timeTokens = timeString.split(':');
       return new Date(currentYear,currentMonth,Number(currentDayString), timeTokens[0], timeTokens[1], timeTokens[2]);
   }
   
   hideErrorAlert(){
     try{
         this.alert = {
             type: 'error',
             message:''
         };
         // Show the alert
         this.showAlert = false;

     }catch{

     }
   }

   toTime2(timeString){
       var timeTokens = timeString.split(':');
       return new Date(1970,0,1, timeTokens[0], timeTokens[1], timeTokens[2]);
   }
    timeConvert (time: any) {
     time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

     if (time.length > 1) {
       time = time.slice (1);
       time[5] = +time[0] < 12 ? 'AM' : 'PM';
       time[0] = +time[0] % 12 || 12;
     }
     return time.join ('');
   }
   convertToLocalDate(responseDate: any) {
     try {
         if (responseDate != null) {
             if (typeof (responseDate) === 'string') {
                 if (String(responseDate.indexOf('T') >= 0)) {
                     responseDate = responseDate.split('T')[0];
                 }
                 if (String(responseDate.indexOf('+') >= 0)) {
                     responseDate = responseDate.split('+')[0];
                 }
             }

             responseDate = new Date(responseDate);
             const newDate = new Date(responseDate.getFullYear(), responseDate.getMonth(), responseDate.getDate(), 0, 0, 0);
             const userTimezoneOffset = newDate.getTimezoneOffset() * 60000;

             const finalDate: Date = new Date(newDate.getTime() - userTimezoneOffset);
             return finalDate > new Date('1/1/0001 12:00:00 AM') ? finalDate : null;
         } else {
             return null;
         }
     } catch (error) {
         return responseDate;
     }
   }
   getFormatedDate(date: Date, format: string) {
     const datePipe = new DatePipe('en-US');
     return datePipe.transform(date, format);
   }
//#endregion Converts

}
function changeFormat(today: Date) {
  throw new Error('Function not implemented.');
}